import { useState, useEffect } from 'react';

import staticdata, { resourceCatalogList } from '@lcsc-ui/apis/staticdata';
import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import { baseURL } from '@lcsc-ui/utils/baseUrl';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import ecpCurl, { setContext, asyncAll } from '@lcsc-ui/utils/ecpCurl';
import Utils from '@lcsc-ui/utils/Utils';
import { Breadcrumb } from 'antd';
import Head from 'next/head';
import Image from 'next/image';
import { NextSeo } from 'next-seo';

import wwwApi from '@/apis/www';
import SelectionList from '@/features/selection/List';

export default function Index({
  resourceData,
  websiteSectionList,
  headerAd,
  selectionCatalogListData,
  selectionProductPageData,
}) {
  const [isLgScreen, setIsLgScreen] = useState(null);
  const [catalogList, setCatalogList] = useState(null);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    resourceCatalogList().then((res) => {
      setCatalogList(res?.result);
    });
    buriedPoint({
      ty: 'enter',
      cp: 'selection_list',
      op: 'view',
      pf: 'pc',
    });
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    setIsLgScreen(Utils.isLgScreen());
  };

  const tagName = '立创芯应用';
  const pathName = 'selection';
  const metadata = {
    title: '元器件选型网-设计方案参考-立创商城',
    description:
      '立创元器件选型网提供各种电路设计参考方案，可以根据电路功能推荐型号，提供详细应用案例，助力电子工程师高效完成电路设计方案开发与元器件选型。',
    additionalMetaTags: [
      {
        name: 'keywords',
        content: '元器件选型网,方案设计参考',
      },
    ],
  };

  return (
    <>
      <NextSeo {...metadata}></NextSeo>
      <Head>
        <link rel="canonical" href={resourceData?.projectConfigVO.lcscWwwUrl + `/${pathName}.html`} />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={isLgScreen}
        notIndexHeaderAdapter
        onlySScreen
        isNeedTopAd
        isShowBottomAd
      >
        <div className="w-full h-full bg-[#f8f8f8]">
          <div className="flex justify-center overflow-hidden">
            <Image
              src="https://static.szlcsc.com/ecp/assets/newWeb/www/selection/banner.jpg"
              alt="立创芯应用"
              width={1920}
              height={258}
            />
          </div>
          <section className="w-[1200px] mx-auto py-[16px]">
            <div className="flex w-full justify-between items-center">
              <Breadcrumb data-spm="bc" separator=">">
                <Breadcrumb.Item data-spm="1" className="hover:!text-[#0093e6]" href={baseURL}>
                  首页
                </Breadcrumb.Item>
                <Breadcrumb.Item className="text-[#0093e6]">{tagName}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <SelectionList
              selectionCatalogListData={selectionCatalogListData}
              selectionProductPageData={selectionProductPageData}
            />
          </section>
        </div>
        <Toolbar></Toolbar>
      </BaseLayout>
    </>
  );
}

export async function getServerSideProps(ctx) {
  setContext(ctx);

  const [resourceData, websiteSectionList, headerAd, selectionCatalogListData, selectionProductPageData, notFound] =
    await asyncAll([
      ecpCurl(staticdata.resourceList, { enableCache: true }),
      ecpCurl(staticdata.websiteSection, { enableCache: true }),
      ecpCurl(staticdata.advertisingHeader, { enableCache: true }),
      ecpCurl(wwwApi.selectionCatalogList),
      ecpCurl(wwwApi.selectionProductPage, {
        query: {
          isHot: true,
          currentPage: 1,
          pageSize: 10,
        },
      }),
    ]);

  if (notFound) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      resourceData,
      websiteSectionList,
      headerAd,
      selectionCatalogListData,
      selectionProductPageData,
    },
  };
}
